import {Button, Popconfirm} from 'antd';

import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {useSnackbar} from '../../../../../provider/snackbar/snackbar-hook';
import {
    isAiMonitoringRunInProgressError,
    useStartAiMonitoringRun,
} from '../../../../../service/ai-brand-monitoring/ai-brand-monitoring-hook';

type PropsType = {
    brandId: number;
    disabled?: boolean;
    onRunFinished: (runId: string) => void;
};

export function RunNowButton(props: PropsType): JSX.Element {
    const {brandId, disabled, onRunFinished} = props;
    const {getLocalizedString} = useLocale();
    const {snackbar} = useSnackbar();

    // The run starts asynchronously (202). We hand its id to the dashboard, which polls the
    // run until it reaches a terminal status and then fills in the results.
    const {mutate, isLoading} = useStartAiMonitoringRun(brandId, {
        onSuccess: (data) => {
            snackbar.success(getLocalizedString('AI_BRAND_MONITORING__RUN__STARTED'));
            onRunFinished(data.runId);
        },
        onError: (error) => {
            if (isAiMonitoringRunInProgressError(error)) {
                snackbar.error(getLocalizedString('AI_BRAND_MONITORING__RUN__IN_PROGRESS'));

                return;
            }

            snackbar.error(getLocalizedString('AI_BRAND_MONITORING__RUN__ERROR'));
        },
    });

    function handleConfirm(): void {
        mutate();
    }

    return (
        <Popconfirm
            cancelText={<Locale stringKey="AI_BRAND_MONITORING__RUN__CONFIRM_CANCEL" />}
            okText={<Locale stringKey="AI_BRAND_MONITORING__RUN__CONFIRM_OK" />}
            onConfirm={handleConfirm}
            title={<Locale stringKey="AI_BRAND_MONITORING__RUN__CONFIRM_TITLE" />}
        >
            <Button disabled={disabled || isLoading} loading={isLoading} type="primary">
                <Locale stringKey="AI_BRAND_MONITORING__RUN__BUTTON" />
            </Button>
        </Popconfirm>
    );
}
